import React from 'react';
import { Box, Button, Stack, Tooltip } from '@customink/pigment-react';
import { Circle } from '@mui/icons-material';
import { TaxExemption } from '~/adapters/services/accounts/tax-exemptions/types';
import { UpperCaseChip } from '~/components/Chip/UpperCaseChip';
import { LinkInBlank } from '~/components/Link/LinkInBlank';
import { useStatusTranslate } from '~/pages/Settings/tabs/TaxExemption/components/Certificate/statusTranslate';

interface TaxExemptionApplicationProps {
    taxExemption: TaxExemption;
}

export const TaxExemptionCertificate: React.FC<TaxExemptionApplicationProps> = ({ taxExemption }) => {
    const translateStatus = useStatusTranslate();
    const internalStatus = translateStatus(taxExemption.completion_state_name);

    return (
        <Stack
            sx={{
                border: 1,
                borderRadius: 1,
                borderColor: 'divider',
                px: 2,
                py: 2,
                mb: 2,
            }}
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
        >
            <Stack flexWrap="wrap" flexDirection="row" justifyContent="flex-start" alignItems="center">
                <Box pr={4}>Certificate</Box>
                <Box pr={1}>{taxExemption.all_stateabbreviations}</Box>
                <Tooltip placement="right" title={internalStatus.tooltipMessage ?? ''}>
                    <Box>
                        <UpperCaseChip
                            icon={<Circle width="50px" style={{ color: internalStatus.color }} />}
                            label={internalStatus.status}
                        />
                    </Box>
                </Tooltip>
            </Stack>
            <Stack flexWrap="wrap" flexDirection="row" justifyContent="flex-end">
                <Button href={taxExemption.download_url} variant="link" LinkComponent={LinkInBlank}>
                    Download
                </Button>
            </Stack>
        </Stack>
    );
};
